/* eslint-disable rxjs-x/no-implicit-any-catch */
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';

import { catchError, Observable, switchMap, throwError } from 'rxjs';

import { ProfileService } from '../modules/profile/profile.service';

export const authorizationInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const authService = inject(ProfileService);

  const accessToken = authService.getAccessToken();

  const authReq = accessToken
    ? req.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
    : req;

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      //if accesstoken expired will throw 401 and try to get new access token
      if (error.status === 401 && !req.url.includes('refresh')) {
        return authService.refreshToken().pipe(
          switchMap(() => {
            const newToken = authService.getAccessToken();
            const retryReq = req.clone({
              setHeaders: { Authorization: `Bearer ${newToken}` },
            });
            return next(retryReq);
          }),

          catchError((retryError: HttpErrorResponse) => {
            //if refresh api fails or gives unauthorized response then logout
            if (
              retryError.status === 401 ||
              retryError.url?.includes('refresh')
            ) {
              authService.logout();
            }
            return throwError(() => retryError);
          }),
        );
      }
      return throwError(() => error);
    }),
  );
};
